module.exports = [
	{
		"name": "Customer Contact Forms (Editable)",
		"papers": [
			{
				"title": "Subscription Agreement",
				"id": "auth0-professional-services-terms",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-word-92c794e490.svg",
				"date": "November, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/Auth0-Subscription-Agmnt-Rev-2.1.0-(11-17)-11-16-17.docx"
					}
				]
			},
			{
				"title": "Professional Services Terms",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-word-92c794e490.svg",
				"date": "October, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-Professional-Services-Terms.docx"
					}
				]
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/editable-subscriptions/data/esPapers.json
// module id = 1411
// module chunks = 0